import { AdminOnly } from '@/components/admin-only'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { Page, PageHeader } from '@/components/rm'
import { UnsavedGuard } from '@/components/unsaved-guard'
import { EmailTemplatesPanel } from '@/components/settings/email-templates-panel'

export const Route = createFileRoute('/_app/templates')({
  component: () => <AdminOnly><TemplatesPage /></AdminOnly>,
})

function TemplatesPage() {
  // The panel reports its own dirty state; leaving the route mid-edit goes through the same confirm
  // it did as a Settings tab, so an unsaved template cannot be lost by a stray nav click.
  const [dirty, setDirty] = useState(false)
  return (
    <Page>
      <UnsavedGuard when={dirty} />
      <PageHeader
        eyebrow="Messaging"
        title="Email templates"
        subtitle="The wording that goes out under your name — reminders, confirmations, thank-yous and review requests. Write it once with merge fields and every automation reuses it."
      />
      <EmailTemplatesPanel onDirty={setDirty} />
    </Page>
  )
}
